// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { repeat } from 'lit/directives/repeat.js';

// Import style for web component
import styles from './web-component-style.scss?inline';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-builder-item-filter' )
export class AutomatorBuilderItemFilter extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// Properties
	// The ID of the filter block. A string for now, but might become an integer (post ID)
	@property( { type: String, attribute: 'filter-id' } ) accessor id;

	// The logic of the filter (any|all)
	@property( { type: String, attribute: 'filter-logic' } ) accessor logic;

	// An array with all the conditions
	@property( { type: Array, attribute: false } ) accessor conditions;

	// The items inside the conditions block
	@property( { type: Array, attribute: false } ) accessor items;

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<div class="filter">
				<div class="filter-header">
					<div class="filter-logic">
						<div class="filter-logic-info">
							<div class="filter-logic-icon">
								<uo-icon id="code-merge"></uo-icon>
							</div>
							<div class="filter-logic-name">
								Run if
							</div>
							<div class="filter-logic-field">
								<uo-button-dropdown>
									<uo-button 
										slot="target"
										color="secondary"
										size="small"
									>
										Any <uo-icon id="angle-down"></uo-icon>
									</uo-button>

									<uo-button color="secondary" size="small">
										Any
									</uo-button>
									<uo-button color="secondary" size="small">
										All
									</uo-button>

								</uo-button-dropdown>
							</div>
							<div class="filter-logic-sentence">
								of the following conditions is met
							</div>
						</div>
						<div class="filter-logic-actions">
							<uo-button class="filter-logic-remove" color="transparent" size="small">
								<uo-icon id="ellipsis"></uo-icon>
							</uo-button>
						</div>
					</div>
					<div class="filter-conditions">
						<div class="filter-condition">
							<div class="filter-condition-icon">
								<uo-icon integration="WP"></uo-icon>
							</div>
							<div class="filter-condition-sentence">
								Post type is <strong>Products</strong>
							</div>
							<div class="filter-condition-buttons">
								<uo-button class="filter-condition-edit" color="transparent" size="small">
									<uo-icon id="pencil"></uo-icon>
								</uo-button>
								<uo-button class="filter-condition-remove" color="transparent" size="small">
									<uo-icon id="trash"></uo-icon>
								</uo-button>
							</div>
						</div>
						<div class="filter-condition">
							<div class="filter-condition-icon">
								<uo-icon integration="WP"></uo-icon>
							</div>
							<div class="filter-condition-sentence">
								Post type is <strong>Products</strong>
							</div>
							<div class="filter-condition-buttons">
								<uo-button class="filter-condition-edit" color="transparent" size="small">
									<uo-icon id="pencil"></uo-icon>
								</uo-button>
								<uo-button class="filter-condition-remove" color="transparent" size="small">
									<uo-icon id="trash"></uo-icon>
								</uo-button>
							</div>
						</div>
					</div>
					<div class="filter-header-actions">
						<uo-button color="secondary" size="extra-small">Add condition</uo-button>
					</div>
				</div>
				<div class="filter-items">
					<div class="filter-item-action"></div>
				</div>
				<div class="filter-actions">
					<uo-button color="secondary" size="small">Add action</uo-button>
				</div>
			</div>
		`;
	}
}
